export default __webpack_public_path__ + "static/media/Boots of Jagged Barbs.a67fc9fc.jpg";